import { useState } from 'react';
import useApi from 'services/mavapi/useApi';
import { ReportService, ShowDetailsReportSummary } from 'services/openapi';

const useShowDetailsApi = () => {
  const [, setError] = useState<unknown | null>();
  const { error: apiError, handleRequest } = useApi();
  const [loading, setLoading] = useState(false);
  const {
    reportGetShowDetailsReportDetails,
    reportGetShowDetailsReportDownload,
  } = ReportService;

  // States
  const [showDetailsData, setShowDetailsData] =
    useState<ShowDetailsReportSummary>();

  const getShowDetails = (
    showId?: string,
    pageNumber: number = 0,
    pageSize: number = 10,
  ) => {
    setLoading(true);
    let pageNumCall = pageNumber ? Math.floor(pageNumber / pageSize) + 1 : 1;
    handleRequest(
      reportGetShowDetailsReportDetails(showId, pageNumCall, pageSize),
    )
      .then(res => {
        setShowDetailsData(res);
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };
  const downloadShowDetails = (showId?: string): Promise<string> => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      handleRequest(reportGetShowDetailsReportDownload(showId))
        .then(res => {
          resolve(res);
          setLoading(false);
        })
        .catch(() => {
          reject(apiError);
          setLoading(false);
        });
    });
  };

  return {
    loading,
    getShowDetails,
    showDetailsData,
    setShowDetailsData,
    downloadShowDetails,
  };
};

export default useShowDetailsApi;
